import React from "react";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getTokenFromLocal } from '../../../_helpers/handleResponseMiddleware';
import { updateCentralAppointmentStatus } from '../../../_services/centralServices/centralCancelAppointment.service';
import { centralReportingDataActions, configActions } from "../../../_actions";

export const CentralInputCheckbox = ({
  label,
  disabled = false,
  appointmentId = null, // Optional: can be passed to identify the correct OT details object
}) => {
  // Get user and reporting data from Redux
  const userDetails = useSelector(state => state.authentication.user);
  const reportingData = useSelector(state => state.centralReportingData);
  const dispatch = useDispatch();

  // Find the correct OT details object
  const appId = appointmentId || reportingData?.activePatientId;
  const activePatientData = reportingData?.reportingData?.data?.find(
    item => item.appointment_id === appId || item._id === appId
  );
  // Checked state is based on otPostponed.value or dischargePostponed.value in the found object
  let checked = false;
  if (label === 'OT Postponed') {
    checked = !!activePatientData?.otPostponed?.value;
  } else if (label === 'Discharge Postponed') {
    checked = !!activePatientData?.dischargePostponed?.value;
  }

  const handleChange = async (event) => {
    const newChecked = event.target.checked;
    const user = userDetails || getTokenFromLocal();
    const leadId = activePatientData?.lead_id;
    dispatch(configActions.showSpinningLoader());
    try {
      let updateObj;
      if (label === "OT Postponed") {
        updateObj = {
          otPostponed: {
            value: newChecked,
            actionTakenBy: user?.userId,
            actionTakenByUser: user?.username || user?.name,
            dateTimeIso: new Date().toISOString(),
            source: "hosChatApp"
          },
          leadId: leadId
        };
      } else {
        updateObj = {
            dischargePostponed: {
            value: newChecked,
            actionTakenBy: user?.userId,
            actionTakenByUser: user?.username || user?.name,
            dateTimeIso: new Date().toISOString(),
            source: "hosChatApp"
          },
          leadId: leadId
        };
      }
      const payload = {
        appId: appId,
        updateObj: updateObj
      };
      const response = await updateCentralAppointmentStatus(payload);
      if (response?.message === 'Success') {
        toast.success(response?.message);
        dispatch(centralReportingDataActions.getCentralReportingData({ "search_query": appId }));
        dispatch(configActions.hideSpinningLoader());
      } else {
        toast.error(response.message);
        dispatch(configActions.hideSpinningLoader());
      }
    } catch (error) {
      console.error('Failed to update OT Postponed status', error);
      toast.error(error?.message);
      dispatch(configActions.hideSpinningLoader());
    }
  };

  return (
    <div>
      <FormControlLabel
      sx={{marginRight:'unset', margin:'5px 0 0'}}
        control={
          <Checkbox
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
            color="primary"
            sx={{
                padding : '0 3px 0 0'
            }}
          />
        }
        label={<span style={{ color: checked ? 'primary' : undefined, fontWeight: checked ? 500 : 400, fontSize: '11px',whiteSpace:'nowrap' }}>{label}</span>}
      />
    </div>
  );
};